import React, { Fragment, useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { contentfulClient } from '../../../contentfulClient.js'

function WorksListContent(props) {
    const [postData, setPostData] = useState([]);
    const [notFound, setNotFound] = useState(false);


    const currentLang = props.currentLang;
    const currentYear = props.currentYear;

    useEffect(() => {
        setPostData([]);
        setNotFound(false);
        const fetchData = async () => {
            const res = await contentfulClient.getEntries({
                content_type: 'works',
                'fields.dateWorked[gte]': currentYear + '-01-01',
                'fields.dateWorked[lte]': currentYear + '-12-31',
                locale: currentLang,
                order: 'fields.dateWorked',
            });
            setPostData([]);
            if (res.items.length > 0 && res.items[0].fields.title) {
                setPostData(res.items);
                // console.log(res);
            } else {
                setNotFound(true);
            };
        };
        fetchData();
    }, [currentLang, currentYear]);

    if (postData.length > 0) {
        return(
            <Fragment>

                {/* Start Contents Area */}
                <div className="row mt_dec--30 ptb--50">
                    {postData.map((post , i ) => (
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt--30" key={i}>
                            <div className="im_box">
                                <div className="thumbnail">
                                    <Link to={'/works/' + post.fields.slug}>
                                        <img className="w-100" src={post.fields.thumb && post.fields.thumb.fields.file ? post.fields.thumb.fields.file.url + "?fit=thumb&w=390&h=532" : '/assets/img/post_placeholder/list/works.jpg'} alt="Work Thumbnail"/>
                                    </Link>
                                </div>
                                <div className="content">
                                    <div className="inner">
                                        <div className="content_heading">
                                            <div className="category_list">
                                                <Link to={'/works/' + post.fields.slug}>{post.fields.tag && post.fields.tag.length > 0 ? post.fields.tag[0].fields.name : 'My Previous Work'}</Link>
                                            </div>
                                            <h4 className="title">
                                                <Link to={'/works/' + post.fields.slug}>{post.fields.title}</Link>
                                            </h4>
                                        </div>
                                        <div className="content_footer">
                                            <Link to={'/works/' + post.fields.slug} className="rn-btn btn-opacity">Learn More</Link>
                                        </div>
                                    </div>
                                    <Link className="transparent_link" to={'/works/' + post.fields.slug}></Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* End Contents Area */}

            </Fragment>
        )
    } else {
        if (notFound) {
            return(
                <Fragment>

                {/* Start Contents Area */}
                <div className="row mt_dec--30 ptb--50 mt--50 mb--150">

                    <h2>Works Not Found.</h2>

                </div>
                {/* End Contents Area */}

                </Fragment>
            )
        } else {
            return(
                <Fragment>

                {/* Start Contents Area */}
                <div className="row mt_dec--30 ptb--50">

                    <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt--30">
                        <div className="im_box">
                            <div className="thumbnail">
                                <Link to="#">
                                    <img className="w-100" src="/assets/img/post_placeholder/list/works.jpg" alt="Work Thumbnail"/>
                                </Link>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <div className="content_heading">
                                        <div className="category_list">
                                            <Link to="#">My Previous Work</Link>
                                        </div>
                                        <h4 className="title">
                                            <Link to="#">Loading...</Link>
                                        </h4>
                                    </div>
                                    <div className="content_footer">
                                        <Link to="#" className="rn-btn btn-opacity">Learn More</Link>
                                    </div>
                                </div>
                                <Link className="transparent_link" to="#"></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt--30">
                        <div className="im_box">
                            <div className="thumbnail">
                                <Link to="#">
                                    <img className="w-100" src="/assets/img/post_placeholder/list/works.jpg" alt="Work Thumbnail"/>
                                </Link>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <div className="content_heading">
                                        <div className="category_list">
                                            <Link to="#">My Previous Work</Link>
                                        </div>
                                        <h4 className="title">
                                            <Link to="#">Loading...</Link>
                                        </h4>
                                    </div>
                                    <div className="content_footer">
                                        <Link to="#" className="rn-btn btn-opacity">Learn More</Link>
                                    </div>
                                </div>
                                <Link className="transparent_link" to="#"></Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt--30">
                        <div className="im_box">
                            <div className="thumbnail">
                                <Link to="#">
                                    <img className="w-100" src="/assets/img/post_placeholder/list/works.jpg" alt="Work Thumbnail"/>
                                </Link>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <div className="content_heading">
                                        <div className="category_list">
                                            <Link to="#">My Previous Work</Link>
                                        </div>
                                        <h4 className="title">
                                            <Link to="#">Loading...</Link>
                                        </h4>
                                    </div>
                                    <div className="content_footer">
                                        <Link to="#" className="rn-btn btn-opacity">Learn More</Link>
                                    </div>
                                </div>
                                <Link className="transparent_link" to="#"></Link>
                            </div>
                        </div>
                    </div>

                </div>
                {/* End Contents Area */}

                </Fragment>
            )
        }
    }
}
export default WorksListContent;